<template>

  <v-footer padless>
        <v-col
          class="text-center bluebg"
          cols="12">


               <table align="center" width="100%">
                   <tr>
                         <td align="left">
                               <img src="../assets/Signature-Marketing.png" style="width:400px;">
                         </td>
                         <td align="right">
                               <img src="../assets/Rogel-Vertical.png" style="height:80px;">
                         </td>
                   </tr>
               </table>
        </v-col>
  </v-footer>


</template>

<script>

export default {
  name: 'Footer',
  components: {

  }
}
</script>
